import CompletedAssessment from '../assessment-completed/assessment-completed';
import InaccurateAssessment from '../assessment-inaccurate/assessment-inaccurate';
import IncompleteAssessment, { IncompleteAssessmentVariant } from '../assessment-incomplete/assessment-incomplete';
import { QuestionnaireStatus } from '../decision-tree';

type RiskAssessmentBannerProps = {
  questionnaireStatus: QuestionnaireStatus;
  variant: IncompleteAssessmentVariant;
  assessmentProgress: number;
  text: string;
};

export default function RiskAssessmentBanner({
  questionnaireStatus,
  variant,
  assessmentProgress,
  text,
}: RiskAssessmentBannerProps) {
  switch (questionnaireStatus) {
    case QuestionnaireStatus.completed:
      return <CompletedAssessment />;
    case QuestionnaireStatus.inaccurate:
      return <InaccurateAssessment assessmentProgress={assessmentProgress} text={text} />;
    case QuestionnaireStatus.uncompleted:
      return <IncompleteAssessment assessmentProgress={assessmentProgress} variant={variant} />;
  }
}
